import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PopupComponent } from 'src/app/components/network-visibility/popup/popup.component';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';

@Component({
  selector: 'app-geo-fence',
  templateUrl: './geo-fence.component.html',
  styleUrls: ['./geo-fence.component.css']
})
export class GeoFenceComponent implements OnInit {
  private map!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];

  form: any | FormGroup
  marker2: any
  cid: any
  layerInfoLatLng: any = []
  objectTemplateList: any = []
  singleObjectTemplateData: any = []
  layerslist: any = []
  singleLayerData: any = []
  defaultZoom: any = 14
  defaultCenter: any = [17.4065, 78.4772]
  lat: any;
  lng: any
  layerType: any = ""
  geojsonData:any = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {
          "name": "Polygon 1"
        },
        "geometry": {}
      }
    ]
  }
  deleteId: any = ""

  objectTemplateId = ""
  objectInfoId: any
  originalCost: any = ""
  currentCost: any = ""
  branch: any = ""
  department: any = ""
  make: any = ""
  model: any = ""
  location: any = ""
  objectCondition: any = ""
  givenName: any = ""
  serialNumber: any = ""
  locationList: any = []
  branchList: any = []
  maintenanceList: any = []

  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]
  file: any = "";
  imagesList: any = [];
  largeImage: any = "";
  todayDate: any;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,private router: Router,
    private injector: Injector) { }

  ngOnInit(): void {
    const now = new Date();
    this.todayDate = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    this.form = this.fb.group({
      layerName: [''],
      layerColor: ['#e01a1a'],
      layerLevel: ['']
    }) 
    this.cid = sessionStorage.getItem('cid')
    // this.initMap()
    this.getAllLayerInfo()
    this.getAllObjectTemplate()
  }

  markerIcon = {
    icon: L.icon({
      iconSize: [25, 41],
      iconAnchor: [10, 41],
      popupAnchor: [2, -40],
      // specify the path here
      iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
      shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
    })
  };

  private initMap(): void {
    console.log("initMap")

    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);


    this.map.on(L.Draw.Event.CREATED,  (event: any) => {
      const layer = event.layer;
 
      console.log(layer)
      console.log(event)
      console.log(layer._latlngs)
      if(event.layerType == "polygon"){
        this.layerType = "Polygon"
        
        drawnItems.addLayer(layer);

        for(let i=0;i < layer._latlngs[0].length;i++){
          this.layerInfoLatLng.push({
            lat: layer._latlngs[0][i].lat,
            lng: layer._latlngs[0][i].lng
          })
        }
        document.getElementById("add-layer-popup")?.click()
      }

      if(event.layerType == "polyline"){
        drawnItems.addLayer(layer);
        this.layerType = "Polyline"
          for(let i=0;i < layer._latlngs.length;i++){
            this.layerInfoLatLng.push({
              lat: layer._latlngs[i].lat,
              lng: layer._latlngs[i].lng
            })
          }
          document.getElementById("add-layer-popup")?.click()
          console.log(this.layerInfoLatLng)
      }

      if(event.layerType == "marker"){
        this.layerType = "Marker"

        this.lat = layer._latlng.lat
        this.lng = layer._latlng.lng
        // for(let i=0;i < layer._latlngs[0].length;i++){
        //   this.layerInfoLatLng.push({
        //     lat: layer._latlngs[0][i].lat,
        //     lng: layer._latlngs[0][i].lng
        //   })
        // }
        if(this.marker2 != undefined){
          this.map.removeLayer(this.marker2);
        }
        document.getElementById("add-device-popup")?.click()
      }

    });

    // var drawnControl = new L.control.Draw();
    // this.map.addLayer(drawnControl);



    const drawnItems = L.featureGroup().addTo(this.map);

    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: drawnItems,
      },
      draw: {
        polygon: true,
        polyline: true,
        marker: true,
        circlemarker: true
      }
    });
    this.map.addControl(drawControl);

    // {
    //   return [
    //     new Leaflet.Polygon([
    //       new Leaflet.LatLng(43.5181349, 16.4537963),
    //       new Leaflet.LatLng(43.517890, 16.439939),
    //       new Leaflet.LatLng(43.515599, 16.446556),
    //       new Leaflet.LatLng(43.518025, 16.463492)
    //     ] as Leaflet.LatLng[],
    //       {
    //         fillColor: '#eb530d',
    //         color: '#eb780d'
    //       } as Leaflet.PolylineOptions)
    //   ] as Leaflet.Polygon[];
    // };

    if(this.singleLayerData.length != 0 && this.singleLayerData != undefined){
    console.log(this.singleLayerData)
    // let layerInfoLatLng = this.singleLayerData[0].latlang

      // for(let i=0;i<this.singleLayerData[0].layerInfoLatLng.length;i++){
 
      //   let obj:any = [
      //     this.singleLayerData[0].layerInfoLatLng[i].lat,
      //     this.singleLayerData[0].layerInfoLatLng[i].lng
      //   ]
      //   layerInfoLatLng.push(obj)
      // }
      // console.log(layerInfoLatLng)

      
      console.log(this.geojsonData)
      console.log(this.geojsonData.features[0].geometry.coordinates)


    let geojsonLayer = L.geoJSON(this.geojsonData,{color: this.geojsonData.layerColor,weight: 10});
    this.map.addLayer(geojsonLayer)


    }

    // let geojsonLayer = L.geoJSON(this.geojsonData,{color: 'red'});
    // this.map.addLayer(geojsonLayer)
  

  //   [
  //     {
  //         "lat": 20.212348320320977,
  //         "lng": 79.7278844886057
  //     },
  //     {
  //         "lat": 19.104239421473036,
  //         "lng": 80.27558503252313
  //     },
  //     {
  //         "lat": 18.649272584200144,
  //         "lng": 79.66491760454694
  //     },
  //     {
  //         "lat": 19.28366189827749,
  //         "lng": 78.39928631678355
  //     },
  //     {
  //         "lat": 20.25373167480533,
  //         "lng": 78.0814839725823
  //     }
  // ]
    



    // let geojsonLayer = L.geoJSON(this.geojsonData,{color: 'red'});
    //   this.map.addLayer(geojsonLayer)

  // drawnItems.addLayer(kk);

  // geojsonLayer.eachLayer(function(layer: any){
  //   layer.enableEdit()
  // });




    // var illustrateControl = new L.Illustrate.Control({
    //   edit: {
    //     featureGroup: drawnItems
    //   }
    // });
    // this.map.addControl(illustrateControl);


    // drawnItems.addLayer(
    //   new L.Illustrate.Pointer(L.latLng(41.7868010411136, -87.60601043701172), [
    //     new L.Point(0, 0),
    //     new L.Point(100, -100),
    //     new L.Point(400, -100)
    //   ])
    // );
    // drawnItems.addLayer(
    //   new L.Illustrate.Pointer(
    //     L.latLng(41.80219068741082, -87.60648250579834),
    //     [new L.Point(0, 0), new L.Point(100, -100), new L.Point(400, -100)]
    //   )
    // );

    // this.map.on("draw:created", function(evt:any) {
    //   var type = evt.layerType,
    //     layer = evt.layer;

    //   drawnItems.addLayer(layer);
    // });

    // this.map.on("click", e => {

    //   console.log(e.latlng);
    //   this.marker2 = new L.Marker(new L.LatLng(e.latlng.lat, e.latlng.lng),this.markerIcon);
    //   console.log(this.marker2);

    //   this.map.addLayer(this.marker2);
    // });


  }

  remove(){
    this.map.removeLayer(this.layerInfoLatLng);
    this.form.reset()
    document.getElementById("closeModalButton")?.click()
    console.log('close')
  }

  defaultIcon = L.icon({
    iconUrl: 'assets/189707.png', // your path may vary ...
    iconSize: [60, 60],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });

  ngOnDestroy(){
    this.map.remove();
  }

  addLayerInfo(){

    console.log(this.form.get('layerColor').value)
    const body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": "",
      "layerInfoId": 0,
      "layerName": String(this.form.get('layerName').value),
      "layerColor": String(this.form.get('layerColor').value),
      "layerLevel": String(this.form.get('layerLevel').value),
      "layerInfoLatLng": this.layerInfoLatLng,
      "layerType": this.layerType,

      "layerObjects": [
        {
          "objectName": "",
          "objectId": "",
          "lat": "",
          "lng": "",
          "objImgUrl": ""
        }
      ],
      "keyValues": [
        {
          "key": "",
          "value": ""
        }
      ],
      "cid":Number(this.cid)
    }
    console.log(body)
    this.generic_service.addLayerInfo(body).subscribe(
      (response: any)=>{
        this.map.remove();
        this.singleLayerData = []
        this.toastr.success(response.message);
        console.log(response)
        this.getAllLayerInfo()
        document.getElementById("closeModalButton")?.click()
        this.initMap()

      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  getAllLayerInfo(){
    this.generic_service.getAllLayerInfo().subscribe(
      (response: any)=>{
        console.log(response)

        this.layerslist = response.response
        this.initMap();


      },
      (error: any)=>{
        console.log(error)
      }
    )
  }


  getLayerInfoByLayerInfoId(layerInfoId: any){
    this.generic_service.getLayerInfoByLayerInfoId(layerInfoId).subscribe(
      (response: any)=>{
        this.map.remove();
        this.singleLayerData = []
        console.log(response)
        let latlang: L.LatLngExpression[] = []
        for(let i=0;i<response.response.layerInfoLatLng.length;i++){
 
          latlang.push(
            [
              parseFloat(response.response.layerInfoLatLng[i].lng),
              parseFloat(response.response.layerInfoLatLng[i].lat)
            ]
          )
          // response.response.layerInfoLatLng[i].lat = Number(response.response.layerInfoLatLng[i].lat)
          // response.response.layerInfoLatLng[i].lng = Number(response.response.layerInfoLatLng[i].lng)
        }
        // response.response.latlang = latlang
        this.defaultZoom = 14
        this.defaultCenter = [parseFloat(response.response.layerInfoLatLng[0].lat),parseFloat(response.response.layerInfoLatLng[0].lng)]
        console.log(this.defaultCenter)
        this.singleLayerData.push(response.response)
        // console.log(this.singleLayerData)
        // this.geojsonData.features[0].geometry.coordinates = latlang

        if(response.response.layerType == 'Polygon' || response.response.layerType == 'polygon'){
          this.geojsonData.features[0].geometry.coordinates = [latlang]
          this.geojsonData.features[0].geometry.type = "Polygon"
        }

        if(response.response.layerType == 'Polyline' || response.response.layerType == 'polyline'){
          this.geojsonData.features[0].geometry.coordinates = latlang
          this.geojsonData.features[0].geometry.type = "LineString"
        }

        if(response.response.layerColor != null && response.response.layerColor != undefined && response.response.layerColor != ""){
          this.geojsonData.layerColor = response.response.layerColor
        }else{
          this.geojsonData.layerColor = "black"

        }

        
        console.log(this.geojsonData)

        this.initMap()
       
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  getAllObjectTemplate(){
    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any)=>{
        console.log(response)
        this.objectTemplateList = response.response
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  getObjectTemplateById(objectTemplateId: any){
    console.log(objectTemplateId.target.value)
    this.generic_service.getObjectTemplateById(objectTemplateId.target.value).subscribe(
      (response: any)=>{
        console.log(response)
        this.singleObjectTemplateData = []

        this.singleObjectTemplateData.push(response.response)
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }



  // addObjectInfo(){

  //   this.singleObjectTemplateData[0].nameValue
  //   delete this.singleObjectTemplateData[0].id
  //   for(let i=0;i<this.singleObjectTemplateData[0].nameValue.length;i++){
  //     if(this.singleObjectTemplateData[0].nameValue[i].key == 'Lat'){
  //       this.singleObjectTemplateData[0].nameValue[i].value = this.lat || ''
  //     }

  //     if(this.singleObjectTemplateData[0].nameValue[i].key == 'Lng'){
  //       this.singleObjectTemplateData[0].nameValue[i].value = this.lng || ''
  //     }
  //   }
  //   console.log(this.singleLayerData)
  //   this.singleObjectTemplateData[0].layerInfoId = this.singleLayerData[0]?.layerInfoId || null
  //   let body = this.singleObjectTemplateData[0]
  //   console.log(body)
  //   this.generic_service.addObjectInfo(body).subscribe(
  //     (response: any)=>{
  //       this.map.remove();
  //       this.singleLayerData = []

  //       console.log(response)
  //       document.getElementById("closeModalButton")?.click()
  //       document.getElementById("closeModalButton1")?.click()
  //       this.toastr.success(response.message);

  //       this.getAllLayerInfo()
  //       this.initMap()

  //     },
  //     (error: any)=>{
  //       this.toastr.error(error.error.errors[0].description);

  //       console.log(error)
  //     }
  //   )
  // }

  seleteDeleteLayerId(id:any){
    this.deleteId = id
  }

  deleteLayerInfo(){
    this.generic_service.deleteLayerInfo(this.deleteId).subscribe(
      (res:any)=>{
        console.log(res)
        this.map.remove();
        this.singleLayerData = []
        this.getAllLayerInfo()
        this.toastr.success("Successfully deleted");
        document.getElementById("deleteModalButton1")?.click()
        this.initMap()
      },err=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
      )
  }


    addMaintenance(){
    this.maintenanceList.push(
      {
        "description": "",
        "maintenanceType": "",
        "frequency": "",
        "nextDueDate": "",
        "lastPerformed": "",
      }
    )
  }

  removeMaintenance(index: any){
    this.maintenanceList.splice(index, 1)
  }

  addMaintenanceSchedule(body: any){
    console.log(body)
    this.generic_service.addMaintenanceSchedule(body).subscribe(
      (response: any)=>{
        console.log(response)
      },
      (error: any)=>{
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }


  addObjectInfo(){
   
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "layerInfoId": 0,
      "name": this.singleObjectTemplateData[0]?.name,
      "type": this.singleObjectTemplateData[0]?.type,
      "group": this.singleObjectTemplateData[0]?.group,
      "originalCost": this.originalCost,
      "objectCondition": this.objectCondition,
      "givenName": this.givenName,
      "serialNumber": this.serialNumber,
      "conditionModifiedBy": [],
      "currentCost": this.currentCost,
      "branch": this.branch,
      "department": this.department,
      "images": this.imagesList,
      "make": this.make,
      "model": this.model,
      "location": this.location,
      "routeId": this.singleObjectTemplateData[0]?.routeId,
      "subGroups": this.singleObjectTemplateData[0]?.subGroups,
      "nameValue": this.singleObjectTemplateData[0]?.nameValue,
      "performanceMatrix": this.singleObjectTemplateData[0]?.performanceMatrix,
      "cid": this.singleObjectTemplateData[0]?.cid,
      "repairInfos": [],
      "multiLatLng": false,

    }

    console.log(body)
    this.generic_service.addObjectInfo(body).subscribe(
      (response: any)=>{
        console.log(response)
        document.getElementById("closeModalButton")?.click()
        document.getElementById("closeModalButton1")?.click()
        this.toastr.success(response.message);

        this.getAllLayerInfo()
        this.initMap()

        for(let list of this.maintenanceList){
          let body = {
            "version": 0,
            "isActive": true,
            "description": list.description,
            "assetId": response.response.objectInfoId,
            "assetName": response.response.givenName,
            "maintenanceType": [
              list.maintenanceType,
            ],
            "frequency": [
              list.frequency,
            ],
            "nextDueDate": list.nextDueDate,
            "lastPerformed": "",
            "cid": Number(this.cid)
          }

          this.addMaintenanceSchedule(body)
        }



        this.toastr.success(response.message);
        this.singleObjectTemplateData = []
        this.originalCost = ""
        this.currentCost = ""
        this.branch = ""
        this.department = ""
        this.objectCondition = ""
        this.givenName = ""
        this.location = ""
        this.serialNumber = ""
        this.imagesList = []
        this.maintenanceList = []
      },
      (error: any)=>{
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }



    addTicketImageBtn(){
    document.getElementById("add-TicketImage-btn")?.click()
  }

  onTicketChange(event: any) {
    this.file = event.target.files[0];
    this.onTicketUpload()
  }

    onTicketUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.imagesList.push(event.response)
    });
  }

  selectLargeImage(largeImage: any){
    this.largeImage = largeImage
  }


}
